import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductComparatorFloatingComponent } from './product-comparator-floating.component';
import { ProductComparatorCardComponent } from './components/product-comparator-mini-card/product-comparator-mini-card.component';
import { RouterModule } from '@angular/router';
import { ScreenViewModule } from '../../../../core/directives/screen-view/_screen-view.module';
import { I18nModule } from '@spartacus/core';

@NgModule({
  declarations: [ProductComparatorFloatingComponent],
  imports: [CommonModule, I18nModule, RouterModule, ScreenViewModule, ProductComparatorCardComponent],
  exports: [ProductComparatorFloatingComponent],
})
export class ProductComparatorFloattingModule {}
